import styled from "styled-components/macro"
import { Box, Heading, Paragraph } from "~styled"

const VideoSectionStyled = styled(Box)`
  padding-top: 60px;
  padding-bottom: 60px;
  background-color: #f9fafb;

  @media (min-width: 768px) {
    padding-top: 80px;
    padding-bottom: 80px;
  }

  @media (min-width: 992px) {
    padding-top: 100px;
    padding-bottom: 100px;
  }
`

VideoSectionStyled.Title = styled(Heading)`
  font-size: 32px;
  font-weight: 500;
  letter-spacing: normal;
  line-height: 1.3;
  margin-bottom: 20px;

  @media (min-width: 768px) {
    font-size: 38px;
  }

  @media (min-width: 992px) {
    font-size: 48px;
  }
`

VideoSectionStyled.SubTitle = styled(Heading)`
  font-size: 16px;
  font-weight: 500;
  letter-spacing: normal;
  line-height: 1.75;
  color: #5034fc;
  margin-bottom: 15px;
  text-transform: uppercase;
`

VideoSectionStyled.Description = styled(Paragraph)`
  font-size: 18px;
  font-weight: 400;
  letter-spacing: normal;
  line-height: 1.77777;
  color: #696969;
  margin-bottom: 30px;

  @media (min-width: 992px) {
    font-size: 20px;
  }
`

VideoSectionStyled.VideoWrapper = styled(Box)`
  position: relative;
  width: 100%;
  margin: 0 auto;

  video {
    display: block;
    width: 100%;
    height: auto;
    border-radius: 10px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  }
`

VideoSectionStyled.PlayButton = styled.button`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 80px;
  background: rgba(80, 52, 252, 0.9);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(80, 52, 252, 0.4);

  &:hover {
    background: rgba(80, 52, 252, 1);
    transform: translate(-50%, -50%) scale(1.1);
    box-shadow: 0 6px 30px rgba(80, 52, 252, 0.6);
  }

  &:active {
    transform: translate(-50%, -50%) scale(0.95);
  }

  @media (min-width: 768px) {
    width: 100px;
    height: 100px;
  }
`

VideoSectionStyled.PlayIcon = styled.span`
  color: white;
  font-size: 28px;
  margin-left: 4px;
  
  @media (min-width: 768px) {
    font-size: 36px;
    margin-left: 6px;
  }
`

export default VideoSectionStyled
